"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNASSIGNED_COLOR = exports.verify = exports.PlayerColors = exports.RoundWatcher = exports.Round = exports.Persistent = exports.Lobby = exports.GlobalConfig = exports.GameWatcher = exports.GameOptions = exports.Game = void 0;
const Game_1 = require("./Game");
Object.defineProperty(exports, "Game", { enumerable: true, get: function () { return Game_1.Game; } });
const GameOptions_1 = require("./GameOptions");
Object.defineProperty(exports, "GameOptions", { enumerable: true, get: function () { return GameOptions_1.GameOptions; } });
const Lobby_1 = require("./Lobby");
Object.defineProperty(exports, "Lobby", { enumerable: true, get: function () { return Lobby_1.Lobby; } });
const Round_1 = require("./Round");
Object.defineProperty(exports, "Round", { enumerable: true, get: function () { return Round_1.Round; } });
const Persistent = require("./Persistent");
exports.Persistent = Persistent;
const Verifier_1 = require("./Verifier");
Object.defineProperty(exports, "verify", { enumerable: true, get: function () { return Verifier_1.verify; } });
const GameWatcher_1 = require("./GameWatcher"); // Not used?
Object.defineProperty(exports, "GameWatcher", { enumerable: true, get: function () { return GameWatcher_1.GameWatcher; } });
Object.defineProperty(exports, "RoundWatcher", { enumerable: true, get: function () { return GameWatcher_1.RoundWatcher; } });
const Colors_1 = require("./Colors");
Object.defineProperty(exports, "PlayerColors", { enumerable: true, get: function () { return Colors_1.PlayerColors; } });
Object.defineProperty(exports, "UNASSIGNED_COLOR", { enumerable: true, get: function () { return Colors_1.UNASSIGNED_COLOR; } });
const GlobalConfig_1 = require("./GlobalConfig");
Object.defineProperty(exports, "GlobalConfig", { enumerable: true, get: function () { return GlobalConfig_1.GlobalConfig; } });
//# sourceMappingURL=index.js.map